import LoginModule from '@oarepo/vue-popup-login'
import * as Sentry from '@sentry/browser'

export function loginGuard (to, from, next) {
  if (LoginModule.store.loggedLocally) {
    // login valid, just call next guard
    next()
  } else {
    // not logged in or login expired - try to fetch login status from the server
    LoginModule.store.performLogIn(loginGuard.Router.app).then(loggedIn => {
      if (loggedIn) {
        // if server says logged in, set sentry user tag and call next guard
        Sentry.configureScope(function (scope) {
          scope.setTag('username', LoginModule.store.authInfo.user.email)
        })
        next()
      } else {
        // otherwise the login is in progress, do not allow transition to the next page
        // the browser will redirect to login server and upon completion will get to 'to' route.
        next(false)
      }
    })
  }
}
